import { __extends, __rest, __spreadArray } from "tslib";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { moveGallection, removeGallection, setGallectionName, } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import MoveToFolderIcon from '@wix/da-ds/pkg/Icons/24x24/MoveToFolder';
import CameraIcon from '@wix/da-ds/pkg/Icons/24x24/AddCoverImage';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GallectionListMenu from '../GallectionListMenu';
import PromptModal from '../../../Popup/PromptModal';
import { getFolderNameValidationErrorMessage, MAX_TITLE_LENGTH, } from '../../../utils/isValidFolderName';
import { isGallectionManageable } from '../../helpers';
import { getSubfoldersByParentId, getFeaturedFolder } from '../../selectors';
import { pushModal } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';
import { connect } from 'react-redux';
import { changeGalleryId as changePortfolioGalleryId } from '../../../WixPortfolio/redux/actions';
import { getCurrentUserHasCore, getCurrentUserHasWixPortfolio, } from '../../../publicSession/selectors';
import PortfolioIcon from '@wix/da-ds/pkg/Icons/Portfolio';
import { GallectionType } from '../../../types/gallection';
import { isPremiumGallection } from '../../../utils/gallections';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import withGallections from '../../_hocs/withGallections';
import GallectionCoverSelector from '../GallectionCoverSelector';
var enhance = compose(withGallections, connectMediaStore(function (state, ownProps) { return ({
    featuredFolder: getFeaturedFolder(state),
    hasSubfolders: getSubfoldersByParentId(state, ownProps.gallection.folderId).length > 0,
    hasCore: getCurrentUserHasCore(state),
    hasWixPortfolio: getCurrentUserHasWixPortfolio(state),
}); }, {
    moveGallection: moveGallection,
    removeGallection: removeGallection,
    setGallectionName: setGallectionName,
}), connect(undefined, function (dispatch) { return ({
    openWixPortfolioModal: function (gallection) {
        dispatch(pushModal(ModalType.WIX_PORTFOLIO_CREATE, { wrapInModal: false }));
        dispatch(changePortfolioGalleryId(gallection.folderId));
    },
}); }), withTranslation());
var GallectionControlButtons = /** @class */ (function (_super) {
    __extends(GallectionControlButtons, _super);
    function GallectionControlButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            popupType: null,
        };
        _this.closePopup = function () {
            _this.setState({ popupType: null });
        };
        _this.openRemoveConfirmationPopup = function () {
            _this.setState({ popupType: 'remove' });
        };
        _this.openRenamePromptPopup = function () {
            _this.setState({ popupType: 'rename' });
        };
        _this.openCoverSelectionPopup = function () {
            _this.setState({ popupType: 'set-cover' });
        };
        _this.remove = function () {
            var props = _this.props;
            props.removeGallection(props.gallection.folderId);
        };
        _this.onValidateName = function (name) {
            var _a = _this.props, t = _a.t, existingGallectionNames = _a.existingGallectionNames, gallection = _a.gallection;
            return getFolderNameValidationErrorMessage(name, t, existingGallectionNames, gallection.type === 'gallery');
        };
        _this.rename = function (name) {
            var folderId = _this.props.gallection.folderId;
            _this.props.setGallectionName({
                folderId: folderId,
                name: name,
            });
            _this.closePopup();
        };
        return _this;
    }
    GallectionControlButtons.prototype.render = function () {
        var _a = this.props, className = _a.className, moreMenuClassName = _a.moreMenuClassName, t = _a.t;
        return (React.createElement(React.Fragment, null,
            React.createElement(ItemControlButtons, { className: className, moreMenuClassName: moreMenuClassName, menuItems: [
                    {
                        // safe zone
                        items: [
                            {
                                value: 1,
                                label: t('mediapopup.itemMenu.rename'),
                                icon: React.createElement(EditIcon, { size: IconSize.SMALL }),
                                onClick: this.openRenamePromptPopup,
                            },
                            {
                                value: 1,
                                label: t('mediapopup.itemMenu.changeCover'),
                                icon: React.createElement(CameraIcon, { size: IconSize.SMALL }),
                                onClick: this.openCoverSelectionPopup,
                            },
                            this.getFolderMoveMenuItem(),
                            this.shouldShowPortfolioOption() &&
                                this.getPortfolioCreateMenuItem(),
                        ].filter(function (item) { return item; }),
                    },
                    {
                        // danger zone
                        items: [
                            {
                                value: 3,
                                label: t('mediapopup.itemMenu.delete'),
                                icon: React.createElement(TrashcanIcon, { size: IconSize.SMALL }),
                                danger: true,
                                onClick: this.remove,
                            },
                        ],
                    },
                ] }),
            this.renderPopup()));
    };
    GallectionControlButtons.prototype.shouldShowPortfolioOption = function () {
        var _a = this.props, gallection = _a.gallection, hasWixPortfolio = _a.hasWixPortfolio;
        return (gallection.type === GallectionType.GALLERY &&
            !gallection.isPortfolioLinked &&
            !hasWixPortfolio);
    };
    GallectionControlButtons.prototype.getPortfolioCreateMenuItem = function () {
        var _a = this.props, t = _a.t, openWixPortfolioModal = _a.openWixPortfolioModal, gallection = _a.gallection;
        return {
            label: t('wixPortfolio.folderSync.menuCreate'),
            icon: React.createElement(PortfolioIcon, { size: IconSize.SMALL }),
            onClick: function () { return gallection && openWixPortfolioModal(gallection); },
            disabled: isPremiumGallection(gallection),
        };
    };
    GallectionControlButtons.prototype.getFolderMoveMenuItem = function () {
        var _a;
        var _b = this.props, gallection = _b.gallection, gallections = _b.gallections, featuredFolder = _b.featuredFolder, hasCore = _b.hasCore, hasSubfolders = _b.hasSubfolders, t = _b.t, props = __rest(_b, ["gallection", "gallections", "featuredFolder", "hasCore", "hasSubfolders", "t"]);
        var isSubfolder = !!gallection.parentId;
        var featuredFolderId = featuredFolder && featuredFolder.folderId;
        if (gallection.type === GallectionType.COLLECTION) {
            return null;
        }
        var label = isSubfolder
            ? t("mediapopup.itemMenu." + gallection.type + ".moveSubfolder")
            : t("mediapopup.itemMenu." + gallection.type + ".moveFolderTo");
        var isPremium = isPremiumGallection(gallection);
        if (isPremium) {
            var tooltipTransKey = ((_a = gallection.premiumFolderData) === null || _a === void 0 ? void 0 : _a.type) === 'paid'
                ? "mediapopup.itemMenu." + gallection.type + ".moveFolderTo.tooltip.disabledAsPaid"
                : "mediapopup.itemMenu." + gallection.type + ".moveFolderTo.tooltip.disabledAsWatchersOnly";
            label = (React.createElement(TextTooltipOnHover, { placement: "right", tooltipText: t(tooltipTransKey), renderReference: function (_a) {
                    var ref = _a.ref;
                    return (React.createElement("span", { style: { pointerEvents: 'all' }, ref: ref }, t("mediapopup.itemMenu." + gallection.type + ".moveFolderTo")));
                } }));
        }
        var isDisabled = !isGallectionManageable(gallection) ||
            // we do not allow more than 1 level of nesting
            // so disallow moving a folder that already has subfolders
            // into another folder
            hasSubfolders ||
            // non-core users can't have subfolders, so a
            // folder can't be moved into a sibling (becoming a sub)
            !hasCore ||
            isPremium;
        return {
            label: label,
            icon: React.createElement(MoveToFolderIcon, { size: IconSize.SMALL }),
            disabled: isDisabled,
            submenu: !isDisabled && (React.createElement(GallectionListMenu
            // For subfolders, we want to allow moving them one level up
            // and turning them into root-level folders. This is done by moving
            // them to the featuredFolder. Thanks back-end.
            , { 
                // For subfolders, we want to allow moving them one level up
                // and turning them into root-level folders. This is done by moving
                // them to the featuredFolder. Thanks back-end.
                firstItem: isSubfolder && featuredFolderId
                    ? {
                        label: t('mediapopup.itemMenu.moveUp'),
                        value: featuredFolderId,
                    }
                    : undefined, onlyTopLevelFolders: true, excludeFolderIds: __spreadArray([
                    gallection.folderId,
                    gallection.parentId
                ], (!isSubfolder && featuredFolderId ? [featuredFolderId] : [])), disableFolderIds: gallections
                    .filter(function (g) { return !!g.premiumFolderData; })
                    .map(function (g) { return g.folderId; }), disableReasonHint: t('mediapopup.itemMenu.gallery.moveFolderTo.tooltip.disabledDueToPremiumDestination'), onSelect: function (toFolderId) {
                    return props.moveGallection({
                        folderId: gallection.folderId,
                        toFolderId: toFolderId,
                    });
                } })),
        };
    };
    GallectionControlButtons.prototype.renderPopup = function () {
        var _a = this.props, gallection = _a.gallection, t = _a.t;
        var popupType = this.state.popupType;
        if (!popupType) {
            return null;
        }
        if (popupType === 'rename') {
            return (React.createElement(PromptModal, { isOpen: true, title: t("mediapopup.gallectionMenu." + gallection.type + ".prompt.rename.title"), inputLabel: t("mediapopup.gallectionMenu." + gallection.type + ".prompt.rename.label"), onInputValidate: this.onValidateName, initialInputValue: gallection.name, onCancel: this.closePopup, doneButtonLabel: t('mediapopup.rename'), onDone: this.rename, maxLength: MAX_TITLE_LENGTH, minLength: 1 }));
        }
        else if (popupType === 'set-cover') {
            return (React.createElement(GallectionCoverSelector, { gallection: gallection, onClose: this.closePopup }));
        }
    };
    return GallectionControlButtons;
}(React.Component));
export { GallectionControlButtons };
export default enhance(GallectionControlButtons);
//# sourceMappingURL=GallectionControlButtons.connected.js.map